export default __webpack_public_path__ + "static/media/MBCorpoSText-Regular.ffdb1324.otf";